"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
const pathProps = {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
};
exports.default = createIconComponent_1.default("Lock", React.createElement(React.Fragment, null,
    React.createElement("path", Object.assign({}, pathProps, { d: "M8.5,9.8H16c1.9,0,3.5,1.6,3.5,3.5v5.1c0,1.9-1.6,3.5-3.5,3.5H8.5c-1.9,0-3.5-1.6-3.5-3.5v-5.1\n\tC5,11.4,6.5,9.8,8.5,9.8z" })),
    React.createElement("path", Object.assign({}, pathProps, { d: "M8.3,9C9.8-0.7,15,1.4,16,5.6" })),
    React.createElement("circle", { cx: "12.2", cy: "15.9", r: "1.6" })));
//# sourceMappingURL=Lock.js.map